<template>
    <div class="p-d-flex p-jc-between">
        <div class="arete-logo-container">
            <div class="text-logo">
                <a href="/" class="p-link">
                    <b>Arete</b> Form Server
                </a>
            </div>
        </div>
        <div class="p-ml-auto p-d-flex">
            <div class="layout-topbar-icons p-mr-3 p-as-center" >
               <button class="p-link" @click="navigateToSettings" v-tooltip.bottom="'Settings'" v-if="isSuperAdmin">
                    <span class="layout-topbar-icon pi pi-cog"></span>
                </button>
                <button class="p-link" @click="navigateToFroms" v-tooltip.bottom="'Forms'">
                    <span class="layout-topbar-icon pi pi-briefcase"></span>
                </button>
                <button class="p-link" @click="navigateToApplications" v-tooltip.bottom="'Applications'">
                    <span class="layout-topbar-icon pi pi-table"></span>
                </button>
            </div>
            <div class="profile-avatar p-as-center" @click="userProfiletoggle" aria-haspopup="true"
                 aria-controls="userProfile_menu">{{userInitials}}</div>
            <Menu id="userProfile_menu" ref="menu" :model="userMenuItems" :popup="true"
                  appendTo="body" />
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      userMenuItems: [
        {
          label: "Logout",
          icon: "pi pi-sign-out",
          command: () => {
            this.logout();
          },
        },
      ],
    };
  },
  computed: {
    userInitials() {
      return this.$store.getters["login/getUserInitials"];
    },
    isSuperAdmin() {
      let loggedUser = this.$store.getters["login/getUser"];
        return loggedUser.isSuperAdmin || false;
    }
  },
  methods: {
    navigateToFroms() {
      this.$router.push({ name: "forms" }).catch(() => {});
    },
    navigateToApplications() {
      this.$router.push({ name: "applications" }).catch(() => {});
    },
    navigateToSettings(){
      this.$router.push({ name: "settings" }).catch(() => {});
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    userProfiletoggle(event) {
      this.$refs.menu.toggle(event);
    },
    logout() {
      this.$store.dispatch("login/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar {
  vertical-align: middle;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

#logocontainer {
  display: inline-flex;
  align-items: center;
}

#logocontainer a {
  margin-left: 0.25rem;
}

.arete-logo-container a {
  margin-left: 0.25rem;
}

.layout-topbar .arete-logo-container .text-logo a {
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 20px;
  padding: 3px;
  text-decoration: none;
}

.layout-topbar .arete-logo-container .text-logo a b {
  font-weight: 600;
}
    .profile-avatar {
        display: inline-block;
        font-size: 1em;
        width: 2.3em;
        height: 2.3em;
        line-height: 2.3em;
        text-align: center;
        border-radius: 50%;
        background: #8da4bd;
        vertical-align: middle;
        color: white;
        cursor: pointer;
    }

    .arete-logo-container a {
        margin-left: 0.25rem;
    }

    .layout-topbar .arete-logo-container .text-logo a {
        color: #fff;
        font-family: 'Poppins', sans-serif;
        font-weight: 300;
        font-size: 20px;
        padding: 3px;
        text-decoration: none
    }

        .layout-topbar .arete-logo-container .text-logo a b {
            font-weight: 600;
        }

    ::v-deep .layout-topbar .layout-topbar-icons button:focus {
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
        outline-color: transparent !important;
        outline-style: none !important;
    }
</style>